import './ErrorMessage.3232a944a7abfd3d94f16c9ca4d9b88c.css';
export default {"errorMessage":"_errorMessage_8cmi5_1","errorIcon":"_errorIcon_8cmi5_1","errorText":"_errorText_8cmi5_1"};